import { searchAttractions } from "../../services/attractionsApi";

/**
 * טוען רשימת אטרקציות מהקטלוג הציבורי (אותו מקור כמו Upsell) לפי יעד / LDS.
 * משמש למיזוג תמונות/תיאורים/מחירי בסיס — GET /rules מחזיר slim בלי שדות אלו.
 *
 * @param {{ flightScopeValue?: string|null, destinationId?: number|null }} input
 * @returns {Promise<Map<number, Record<string, unknown>>>}
 */
export async function fetchCatalogForPackageProfile({
  flightScopeValue = null,
  destinationId = null,
} = {}) {
  const fv =
    flightScopeValue != null && String(flightScopeValue).trim() !== ""
      ? String(flightScopeValue).trim()
      : "";
  const did =
    destinationId != null && destinationId !== ""
      ? Number(destinationId)
      : NaN;

  try {
    const params = { for_packages: true, limit: 200 };
    if (fv) {
      params.lds_code = fv;
    } else if (Number.isFinite(did) && did > 0) {
      params.destination_id = did;
    } else {
      return new Map();
    }
    const data = await searchAttractions(params);
    const list = Array.isArray(data?.attractions) ? data.attractions : [];
    const m = new Map();
    for (const a of list) {
      if (a == null || a.id == null) continue;
      const id = Number(a.id);
      if (Number.isFinite(id)) m.set(id, a);
    }
    return m;
  } catch {
    return new Map();
  }
}
